const {
  GET_EMAILS,
  GET_LANDING_DOMAIN_LIST,
  UPDATE_EMAIL,
  RETRIEVE_EMAIL,
  SPEAR_PHISHING_CAMPAIGN_DATA_POLLING,
  UPDATE_PARTICIPANTS,
} = require('./constants')

export const getEmails = (campaignId) => ({
  type: GET_EMAILS.INITIATE,
  payload: { campaignId },
})
export const getEmailsSuccess = (data) => ({
  type: GET_EMAILS.SUCCESS,
  payload: { data },
})
export const getEmailsError = (error) => ({
  type: GET_EMAILS.ERROR,
  error,
})
export const getEmailsCancel = () => ({
  type: GET_EMAILS.CANCEL,
})

export const updateEmail = (scenarioId, data) => ({
  type: UPDATE_EMAIL.INITIATE,
  payload: { scenarioId, data },
})
export const updateEmailSuccess = (data) => ({
  type: UPDATE_EMAIL.SUCCESS,
  payload: { data },
})
export const updateEmailError = (error) => ({
  type: UPDATE_EMAIL.ERROR,
  payload: { error },
})

export const retrieveEmail = (scenarioId) => ({
  type: RETRIEVE_EMAIL.INITIATE,
  payload: { scenarioId },
})
export const retrieveEmailSuccess = (data) => ({
  type: RETRIEVE_EMAIL.SUCCESS,
  payload: { data },
})
export const retrieveEmailError = (error) => ({
  type: RETRIEVE_EMAIL.ERROR,
  payload: { error },
})
export const retrieveEmailCancel = () => ({
  type: RETRIEVE_EMAIL.CANCEL,
})

export const spearPhishingCampaignDataPolling = (campaignId) => ({
  type: SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.INITIATE,
  payload: { campaignId },
})
export const spearPhishingCampaignDataPollingSuccess = (data) => ({
  type: SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.SUCCESS,
  payload: { data },
})
export const spearPhishingCampaignDataPollingError = (error) => ({
  type: SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.ERROR,
  error,
})
export const spearPhishingCampaignDataPollingCancel = () => ({
  type: SPEAR_PHISHING_CAMPAIGN_DATA_POLLING.CANCEL,
})

export const getLandingDomainList = () => ({ type: GET_LANDING_DOMAIN_LIST.INITIATE })
export const getLandingDomainListSuccess = (data) => ({
  type: GET_LANDING_DOMAIN_LIST.SUCCESS,
  payload: { data },
})
export const getLandingDomainListError = (error) => ({
  type: GET_LANDING_DOMAIN_LIST.ERROR,
  error,
})
export const getLandingDomainListCancel = () => ({
  type: GET_LANDING_DOMAIN_LIST.CANCEL,
})

export const updateParticipants = (campaignId) => ({
  type: UPDATE_PARTICIPANTS.INITIATE,
  payload: { campaignId },
})
export const updateParticipantsSuccess = (data) => ({
  type: UPDATE_PARTICIPANTS.SUCCESS,
  payload: { data },
})
export const updateParticipantsError = (error) => ({
  type: UPDATE_PARTICIPANTS.ERROR,
  error,
})
export const updateParticipantsCancel = () => ({
  type: UPDATE_PARTICIPANTS.CANCEL,
})

export default {
  // to props
  getEmails,
  getLandingDomainList,
  getLandingDomainListCancel,
  updateEmail,
  retrieveEmail,
  retrieveEmailCancel,
  spearPhishingCampaignDataPolling,
  updateParticipants,
}
